'use strict';

var Finance = require('financejs');
var wNumb = require('wnumb');
var isNumeric = require('../lib/isNumeric.js');

function init() {
	var form = document.getElementById('comLoanCalc');
	if (!form)
		return;

	var finance = new Finance;

	// General Elements
	var button = document.getElementsByClassName('submit')[0];
	var outputDiv = document.getElementsByClassName('comLoanCalc__result')[0];
	var outputSpan = document.getElementById('comLoanCalc__number');

	// Input Fields
	var amountEl = document.getElementById('comLoanCalc\:amount');
	var interestEl = document.getElementById('comLoanCalc\:interest');
	var amortizationEl = document.getElementById('comLoanCalc\:amortization');

	// Error Elements
	var errorDiv = document.getElementsByClassName('messages')[0];
	var errorOutputDiv = errorDiv.getElementsByClassName('inner')[0];

	var moneyFormat = wNumb({
		decimals: '2',
		mark: '.',
		thousand: ',',
		prefix: '$',
	});

	function calculateAmortization() {
		var noSpecialRegex = /[^\.0-9]/g;
		var num = {
			amount: parseFloat(amountEl.value.replace(noSpecialRegex, '')),
			interest: parseFloat(interestEl.value.replace(noSpecialRegex, '')),
			amortization: parseFloat(amortizationEl.value.replace(noSpecialRegex, ''))
		}

		var invalid = [];
		for (var prop in num) {
			if (!isNumeric(num[prop]))
				invalid.push(prop);
		}

		var result = undefined;

		if (num.interest === 0) {
			result = num.amount / num.amortization;
		} else {
			result = finance.AM(num.amount, num.interest, num.amortization, 0);
		}

		if (isNumeric(result)) {
			return result;
		} else {
			throw new InputException(invalid);
		}
	}

	function handleClick(event) {
		try {
			var output = moneyFormat.to(calculateAmortization());
			outputDiv.classList.remove('comLoanCalc__result--hidden');
			outputSpan.innerText = output;

			errorDiv.classList.add('messages--hidden');
			errorOutputDiv.innerHTML = '';
		} catch(e) {
			outputDiv.classList.add('comLoanCalc__result--hidden');
			errorOutputDiv.innerHTML = e.message;
			errorDiv.classList.remove('messages--hidden');
			return;
		}
	}

	button.addEventListener('click', handleClick);

	function InputException(errorArr, message) {
		this.errors = '';
		for (var i = 0; i < errorArr.length;i++) {
			this.errors += '<li>"' + errorArr[i] + '" is required to be a valid number.</li>'
		}
		if (this.errors) {
			this.message = '<p>Please resubmit the form after addressing the following:</p><ul>' + this.errors + '</ul>';
		} else {
			this.message = '<p>Something went wrong. Please check your values and try again.</p>';
		}
	}
}

module.exports = {
	init: init
}